import React from "react";
import AdminLogs from "../../components/ProjectLogs/AdminLogs";

const Dashboard = () => {
  return <AdminLogs />;
};

export default Dashboard;
